import React, { Component } from 'react';
import { IStartChargePageProps } from '../../types/propTypes';
import { IStartChargePageState } from '../../types/stateTypes';
import { IDriverDetail, IStartChargeForm } from '../../models/driver';
import DriverService from '../../services/driver/driver-service';
import StandardResponse from '../../models/standard-response';
import { toast } from 'react-toastify';
import { Formik, Field } from 'formik';
import { StartChargeValidationSchema } from '../../validation/driver/startCharge-validation';
import {
    ReactstrapLabel,
    AsyncSelectBox,
    SelectBox,
    ReactstrapCheckbox,
    ReactstrapInput,
} from '../../components/reactstrap-formik';
import ChargeStationService from '../../services/charge-station/charge-station-service';
import { IChargeLocation, IChargeLocationList } from '../../models/charge-station';
import CommonService from '../../services/common/common-service';
import { Common } from '../../utils/constants';
import { IRFIDCardsList } from '../../models/rfid-cards';
import { ILookupDetailColumn } from '../../models/common-models';
import _ from 'lodash';
import { t } from 'i18next';
import images from '../../assets/images/index';

export class StartChargePage extends Component<IStartChargePageProps, IStartChargePageState> {
    state: IStartChargePageState;
    private driverService: DriverService;
    chargeStationService: ChargeStationService;
    commonService: CommonService;
    private intialValues: IStartChargeForm = {
        first_name: '',
        last_name: '',
        address: '',
        postal_code: '',
        location: null,
        station: null,
        connector: null,
        limitedKWH: false,
        confirmationCheck: false,
        phoneNumber: '',
        email: '',
        rfidCard: null,
    };
    constructor(props) {
        super(props);
        this.state = {
            chargeStationsList: [],
            connectorsList: [],
            limitedkWhValue: '',
            isLocationSelected: false,
            isStationSelected: false,
            isSpecialAccount: false,
            rfidCardsList: [],
            isFleetDriverAccount: false,
            organisationID: null,
            password: '',
            confirmationCheck: false,
            status_id: null,
            address: null,
        };
        this.driverService = new DriverService();
        this.chargeStationService = new ChargeStationService();
        this.commonService = new CommonService();
    }

    async componentDidMount() {
        let driverDetails: IDriverDetail;
        driverDetails = this.props.driverDetails;
        if (driverDetails) {
            this.intialValues = {
                first_name: driverDetails.first_name || '',
                last_name: driverDetails.last_name || '',
                address: driverDetails.address || '',
                postal_code: driverDetails.postal_code || '',
                location: null,
                station: null,
                connector: null,
                limitedKWH: false,
                confirmationCheck: false,
                phoneNumber: '',
                email: driverDetails.email || '',
                rfidCard: '',
            };
            this.setState({ ...this.state, address: driverDetails?.address });
        }
        const limitedkWhValue = await this.getConfigDetails(Common.ConfigurationKey.LIMITED_KWH);
        const limitedKWHEmail = await this.getConfigDetails(Common.ConfigurationKey.LIMITED_KWH_EMAIL_ACCOUNT);
        if (limitedkWhValue) {
            this.setState({ limitedkWhValue: limitedkWhValue });
        }
        if (driverDetails && driverDetails.email && driverDetails.email === limitedKWHEmail) {
            this.intialValues = {
                first_name: '',
                last_name: '',
                address: '',
                postal_code: '',
                location: null,
                station: null,
                connector: null,
                limitedKWH: true,
                confirmationCheck: true,
                phoneNumber: '',
                email: '',
                rfidCard: '',
            };
            this.setState({ isSpecialAccount: true });
        }
        if (driverDetails.organisation !== null) {
            this.intialValues = {
                first_name: driverDetails.first_name,
                last_name: driverDetails.last_name,
                address: driverDetails.address,
                postal_code: driverDetails.postal_code,
                location: null,
                station: null,
                connector: null,
                limitedKWH: false,
                confirmationCheck: false,
                phoneNumber: '',
                email: driverDetails.email ? driverDetails.email : '',
                rfidCard: null,
                vehicle_number: driverDetails.vehicle_number,
            };
            const rfidCardsList = await this.getRFIDCardsList();
            this.setState({
                isFleetDriverAccount: true,
                rfidCardsList: rfidCardsList,
                organisationID: driverDetails.organisation.id,
                password: driverDetails.organisation.password,
            });
        }

        const lookupList: Array<any> = await this.getLookupDetailList();
        const lookup = lookupList.find((x) => x.code === Common.LookupCode.EVSE_STATUS);
        const lookup_details = lookup.lookup_details.filter(
            (x: ILookupDetailColumn) => x.code === Common.StationStatus.AVAILABLE,
        );

        const availableStationStatusId = lookup_details[0].id;
        if (availableStationStatusId) {
            this.setState({
                ...this.state,
                status_id: availableStationStatusId,
            });
        }
    }

    getConfigDetails = async (code: string) => {
        let config = '';
        const filterInput = {
            code: code,
        };
        await this.commonService
            .getConfiguration(filterInput)
            .then(async (res: any) => {
                let data = res.data;
                config = data.filter((value) => {
                    return value.reference_code === code;
                })[0].value;
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            })
            .finally();
        return config;
    };

    getLookupDetailList = async () => {
        let lookupList: Array<any> = [];
        const filterInput = {
            code: [Common.LookupCode.EVSE_STATUS],
        };
        await this.commonService
            .getLookupDetailList(filterInput)
            .then(async (res: StandardResponse<any>) => {
                if (_.isArray(res.Data)) {
                    lookupList = res.Data;
                }
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            })
            .finally();
        return lookupList;
    };

    loadOptions = async (value) => {
        const { t } = this.props;
        let chargeLocationsList: Array<any> = [];
        if (value.length >= 3) {
            const filterInput = {
                limit: 10,
                offset: 0,
                order: [['name', 'asc']],
                status_id: [this.state.status_id],
                charge_location_name: value,
            };
            await this.chargeStationService
                .getChargeStations(filterInput)
                .then((res: StandardResponse<IChargeLocationList>) => {
                    chargeLocationsList = res?.Data?.rows?.filter((item: any) => !item?.is_external);
                    if (chargeLocationsList.length === 10) {
                        let messageOption = {
                            name: t('continueTypingSearch'),
                            isdisabled: true,
                        };
                        chargeLocationsList.push(messageOption);
                    }
                })
                .catch((m) => {
                    if (m.response && m.response.data && m.response.data.message) {
                        toast.error(m.response.data.message);
                    } else {
                        toast.error(m.toString());
                    }
                });
        } else {
            let messageOption = {
                name: t('startChargePageDropDownDefaultMessage'),
                isdisabled: true,
            };
            chargeLocationsList.push(messageOption);
        }
        return chargeLocationsList;
    };

    getRFIDCardsList = async () => {
        const { id } = this.props;
        let rfidCardsList;
        let activatedCards;
        let filterInput = {};
        await this.driverService
            .getRFIDCardsList(id, filterInput)
            .then(async (res: StandardResponse<IRFIDCardsList>) => {
                rfidCardsList = res.Data.rows;
                activatedCards = rfidCardsList.filter((card) => card.status.code === Common.RFID_CARD_STATUS.ACTIVATED);
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
        return activatedCards;
    };

    handleSubmit = async (values) => {
        const { id, t } = this.props;
        const data = {};
        if (values.location.id && values.station.id && values.connector.id) {
            Object.assign(data, {
                driver_id: id,
                charge_location_id: values.location.id,
                charge_station_id: values.station.id,
                charge_station_connector_id: values.connector.id,
                is_limited_kwh_session: values.limitedKWH,
            });
        }
        if (this.state.isSpecialAccount && values.first_name && values.email && values.phoneNumber) {
            Object.assign(data, {
                is_special_account: true,
                full_name: values.first_name,
                email: values.email,
                phone_number: values.phoneNumber,
            });
        }
        if (this.state.isFleetDriverAccount && this.state.organisationID && values.rfidCard.public_card_id) {
            Object.assign(data, {
                public_card_id: values.rfidCard.public_card_id,
                organisation_id: this.state.organisationID,
            });
        }
        await this.driverService
            .startRemoteCharge(data, values?.location?.mutual_ocpi_version)
            .then(async (res: StandardResponse<any>) => {
                toast.success(t('driver.label.chargingStartedMessage'));
                this.props.toggleClosePage();
            })
            .catch((m) => {
                if (m.response && m.response.data && (m.response.data.status_message || m.response.data.message)) {
                    toast.error(m.response.data.status_message || m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            })
            .finally();
    };

    handleLocationChange = (location) => {
        if (location !== null && Object.keys(location).length > 0) {
            let chartgeStationsList = location.evses.filter((evses) => evses.status === t('driver.label.available'));
            if (chartgeStationsList) {
                this.setState({
                    isLocationSelected: true,
                    isStationSelected: false,
                    chargeStationsList: chartgeStationsList,
                });
            }
        } else {
            this.setState({
                isLocationSelected: false,
                isStationSelected: false,
                chargeStationsList: [],
                connectorsList: [],
            });
        }
    };

    handleStationChange = (station) => {
        if (station !== null && Object.keys(station).length > 0) {
            if (station.connectors) {
                this.setState({ isStationSelected: true, connectorsList: station.connectors });
            }
        } else {
            this.setState({ isStationSelected: false, connectorsList: [] });
        }
    };

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="title row align-items-content justify-content-between pb-3">
                    <div className="col-auto col-sm text-truncate pr-0">
                        <h1 className="text-truncate">{t('driver.startCharge')}</h1>
                    </div>
                    <div className="col-auto">
                        <div className="btn-list">
                            <button
                                title={t('driver.button.back')}
                                type="button"
                                className="btn btn-icon pr-0 btn-outline-primary"
                                onClick={() => this.props.toggleClosePage()}
                            >
                                <img className="icon" src={images.backArrowSVG} alt={t('driver.button.back')} />
                            </button>
                        </div>
                    </div>
                </div>
                <Formik
                    enableReinitialize
                    initialValues={this.intialValues}
                    onSubmit={this.handleSubmit}
                    validationSchema={StartChargeValidationSchema(
                        t,
                        this.state.isSpecialAccount,
                        this.state.isFleetDriverAccount,
                    )}
                    render={(props) => {
                        const { handleSubmit, setFieldTouched, setFieldValue, touched, errors, values } = props;

                        return (
                            <form className="form-primary-info" onSubmit={handleSubmit} autoComplete="off">
                                <div className="card-outer pt-3 pl-3 pr-3">
                                    <div className="title row align-items-content justify-content-between pb-3">
                                        <div className="col-auto col-sm text-truncate pr-0">
                                            <h3 className="text-truncate">{t('driver.detail')}</h3>
                                        </div>
                                    </div>
                                    {this.state.isSpecialAccount && (
                                        <div className="row">
                                            <div className="form-group col-md-6 col-lg-4">
                                                <Field
                                                    name="first_name"
                                                    placeholder={t('driver.label.fullName')}
                                                    label={t('driver.label.fullName')}
                                                    maxLength={40}
                                                    component={ReactstrapInput}
                                                />
                                            </div>
                                            <div className="form-group col-md-6 col-lg-4">
                                                <Field
                                                    name="phoneNumber"
                                                    maxLength={15}
                                                    placeholder={t('driver.label.phoneNo')}
                                                    label={t('driver.label.phoneNo')}
                                                    component={ReactstrapInput}
                                                />
                                            </div>
                                            <div className="form-group col-md-6 col-lg-4">
                                                <Field
                                                    type="text"
                                                    name="email"
                                                    placeholder={t('user.placeholder.email')}
                                                    label={t('user.label.email')}
                                                    component={ReactstrapInput}
                                                    maxLength={50}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {!this.state.isSpecialAccount && (
                                        <>
                                            <div className="row">
                                                <div className="col-md-6 col-lg-4">
                                                    <Field
                                                        name="first_name"
                                                        placeholder={t('driver.placeholder.firstName')}
                                                        label={t('driver.label.firstName')}
                                                        maxLength={20}
                                                        component={ReactstrapLabel}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <Field
                                                        name="last_name"
                                                        placeholder={t('driver.placeholder.lastName')}
                                                        label={t('driver.label.lastName')}
                                                        maxLength={20}
                                                        component={ReactstrapLabel}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="col-md-6 col-lg-4">
                                                    <label>{t('driver.label.address')}</label>
                                                    <p style={{ whiteSpace: 'pre-line', fontWeight: 'bold' }}>
                                                        {this.state.address}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                {values.vehicle_number && (
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <Field
                                                            name="vehicle_number"
                                                            placeholder={t('driver.label.vehicleNumber')}
                                                            label={t('driver.label.vehicleNumber')}
                                                            maxLength={40}
                                                            component={ReactstrapLabel}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}

                                    <div className="title row align-items-content justify-content-between pb-3">
                                        <div className="col-auto col-sm text-truncate pr-0">
                                            <h3 className="text-truncate">{t('driver.chargeDetails')}</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4">
                                            <Field name="location">
                                                {({ field }) => (
                                                    <div>
                                                        <AsyncSelectBox
                                                            {...field}
                                                            placeholder={t('driver.placeholder.chargeLocation')}
                                                            label={t('driver.label.chargeLocation')}
                                                            labelClass="mb-5p"
                                                            className={
                                                                Boolean(touched[field.name] && errors[field.name])
                                                                    ? 'form-group is-invalid'
                                                                    : 'form-group'
                                                            }
                                                            loadOptions={(value) => this.loadOptions(value)}
                                                            isMulti={false}
                                                            cacheOptions={false}
                                                            onChange={(value: IChargeLocation) => {
                                                                setFieldValue(field.name, value);
                                                                setFieldTouched(field.name, true);
                                                                setFieldValue('station', '');
                                                                setFieldValue('connector', '');
                                                                this.handleLocationChange(value);
                                                            }}
                                                            defaultOptions={[
                                                                {
                                                                    name: t('startChargePageDropDownDefaultMessage'),
                                                                    isdisabled: true,
                                                                },
                                                            ]}
                                                            onBlur={() => setFieldTouched(field.name, true)}
                                                            getOptionLabel={(opt: IChargeLocation) => {
                                                                return opt.name;
                                                            }}
                                                            styles={customStyles}
                                                            getOptionValue={(opt: IChargeLocation) => opt.id}
                                                            touched={touched[field.name]}
                                                            errors={errors[field.name]}
                                                            isClearable={true}
                                                            isOptionDisabled={(option) => option.isdisabled}
                                                        />
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="form-group col-md-6 col-lg-4">
                                            <Field name="station">
                                                {({ field }) => (
                                                    <div>
                                                        <SelectBox
                                                            {...field}
                                                            placeholder={t('driver.placeholder.chargeStation')}
                                                            label={t('driver.label.chargeStation')}
                                                            className={
                                                                Boolean(touched[field.name] && errors[field.name])
                                                                    ? 'form-group is-invalid'
                                                                    : 'form-group'
                                                            }
                                                            value={values.station}
                                                            options={this.state.chargeStationsList}
                                                            isMulti={false}
                                                            onChange={(value) => {
                                                                setFieldValue(field.name, value);
                                                                setFieldTouched(field.name, true);
                                                                setFieldValue('connector', '');
                                                                this.handleStationChange(value);
                                                            }}
                                                            onBlur={() => setFieldTouched(field.name, true)}
                                                            getOptionLabel={(opt) => opt.physical_reference}
                                                            getOptionValue={(opt) => opt.id}
                                                            touched={touched[field.name]}
                                                            errors={errors[field.name]}
                                                            isClearable={true}
                                                            isDisabled={!this.state.isLocationSelected}
                                                        />
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="form-group col-md-6 col-lg-4">
                                            <Field name="connector">
                                                {({ field }) => (
                                                    <div>
                                                        <SelectBox
                                                            {...field}
                                                            placeholder={t('driver.placeholder.connector')}
                                                            label={t('driver.label.connector')}
                                                            className={
                                                                Boolean(touched[field.name] && errors[field.name])
                                                                    ? 'form-group is-invalid'
                                                                    : 'form-group'
                                                            }
                                                            value={values.connector}
                                                            options={this.state.connectorsList}
                                                            isMulti={false}
                                                            onChange={(value) => {
                                                                setFieldValue(field.name, value);
                                                                setFieldTouched(field.name, true);
                                                            }}
                                                            onBlur={() => setFieldTouched(field.name, true)}
                                                            getOptionLabel={(opt) => opt.standard}
                                                            getOptionValue={(opt) => opt.id}
                                                            touched={touched[field.name]}
                                                            errors={errors[field.name]}
                                                            isClearable={true}
                                                            isDisabled={
                                                                !this.state.isLocationSelected ||
                                                                !this.state.isStationSelected
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                    {this.state.isFleetDriverAccount && (
                                        <div className="row">
                                            <div className="form-group col-md-6 col-lg-4">
                                                <Field name="rfidCard">
                                                    {({ field }) => (
                                                        <div>
                                                            <SelectBox
                                                                {...field}
                                                                placeholder={t('driver.placeholder.rfidCard')}
                                                                label={t('driver.label.rfidCard')}
                                                                className={
                                                                    Boolean(touched[field.name] && errors[field.name])
                                                                        ? 'form-group is-invalid'
                                                                        : 'form-group'
                                                                }
                                                                value={values.rfidCard}
                                                                options={this.state.rfidCardsList}
                                                                isMulti={false}
                                                                onChange={(value) => {
                                                                    setFieldValue(field.name, value);
                                                                    setFieldTouched(field.name, true);
                                                                }}
                                                                onBlur={() => setFieldTouched(field.name, true)}
                                                                getOptionLabel={(opt) => opt.public_card_id}
                                                                getOptionValue={(opt) => opt.id}
                                                                touched={touched[field.name]}
                                                                errors={errors[field.name]}
                                                                isClearable={true}
                                                            />
                                                        </div>
                                                    )}
                                                </Field>
                                            </div>
                                        </div>
                                    )}
                                    <div className="row">
                                        <div className="col-md-6 col-lg-4 col-xl-3">
                                            <Field
                                                name="limitedKWH"
                                                id="limitedKWH"
                                                placeholder={
                                                    t('driver.placeholder.limitedKWH') +
                                                    ' ' +
                                                    this.state.limitedkWhValue
                                                }
                                                label={t('driver.label.limitedKWH') + ' ' + this.state.limitedkWhValue}
                                                component={ReactstrapCheckbox}
                                                disabled={this.state.isSpecialAccount}
                                            />
                                        </div>
                                    </div>
                                    {!this.state.isSpecialAccount && (
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12 col-xl-12">
                                                <Field
                                                    name="confirmationCheck"
                                                    id="confirmationCheck"
                                                    placeholder={t('driver.placeholder.confirmationNote')}
                                                    label={
                                                        !this.state.isFleetDriverAccount
                                                            ? t('driver.placeholder.confirmationNote')
                                                            : t('driver.placeholder.confirmationNoteFleet') +
                                                              this.state.password
                                                    }
                                                    component={ReactstrapCheckbox}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="form-group col-md-auto">
                                            <button
                                                type="submit"
                                                disabled={
                                                    !values.location ||
                                                    !values.station ||
                                                    !values.connector ||
                                                    Object.keys(errors).length > 0 ||
                                                    (!values.confirmationCheck && !this.state.isSpecialAccount) ||
                                                    (this.state.isFleetDriverAccount && !values.rfidCard) ||
                                                    (this.state.isSpecialAccount &&
                                                        (!values.first_name || !values.email || !values.phoneNumber))
                                                }
                                                className="btn btn-primary mr-2"
                                                title={t('driver.button.startChargeBtn')}
                                            >
                                                <span>{t('driver.button.startChargeBtn')}</span>
                                            </button>
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => this.props.toggleClosePage()}
                                                title={t('driver.button.cancel')}
                                            >
                                                <span>{t('driver.button.cancel')}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                ></Formik>
            </>
        );
    }
}
const customStyles = {
    option: (styles, { isDisabled }) => {
        return {
            ...styles,
            color: isDisabled ? '#004687' : '',
            cursor: isDisabled ? 'not-allowed' : 'default',
        };
    },
};
export default StartChargePage;
